// SlidePanel.body has no internal padding — add page-like padding
// around the embedded tasks-table so it doesn't sit flush against the
// drawer chrome (header + close button + edges).

.body {
  padding: 24px 32px;
}
